<div class="flyaout">
    <div class="flyaout-body">
        <h2 class="flyaout-welcome">Bienvenido</h2>
        <div class="flyaout-logo"><img src="../../../assets/images/YPF_logo_logotype.png" /> </div>
    </div>
</div>